import { useState, useEffect } from 'react';
import Logo from "../assets/Icon/applogo.svg";
import secureLocalStorage from 'react-secure-storage';
import { BASE_URL } from '../config';

const PageLoader = ({ loading }) => {
  const lightLogo = secureLocalStorage.getItem("light_logo") || "";
  const logoSrc = lightLogo ? (BASE_URL + lightLogo) : Logo;

  const [show, setShow] = useState(false);

  useEffect(() => {
    let timer;

    if (loading) {
      setShow(true);
    } else {
      timer = setTimeout(() => {
        setShow(false);
      }, 1000);
    }

    document.body.style.overflow = loading ? "hidden" : "auto";

    return () => clearTimeout(timer);
  }, [loading]);

  if (!show) return null;

  return (
    <div className={`loader_page ${!loading ? "fade-out" : ""}`}>
      <div className="loader w-[60px] h-[60px]">
      </div>
      <img
        src={logoSrc}
        className="w-[45px] h-[45px] rounded-full absolute object-contain"
        alt="Logo"
      />
    </div>
  )
}

export default PageLoader